export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
  metadata?: ChatMetadata;
}

export interface ChatMetadata {
  answerScore?: number;
  feedback?: string[];
  suggestions?: string[];
  questionCategory?: string;
  isFollowUpQuestion?: boolean;
  additionalData?: Record<string, any>;
}

export interface ChatRequest {
  message: string;
  sessionId?: string;
  interviewType?: InterviewType;
  jobRole?: string;
  companyName?: string;
  experienceLevel?: ExperienceLevel;
  conversationHistory?: ChatMessage[];
}

export interface ChatResponse {
  message: string;
  sessionId: string;
  timestamp: string;
  metadata?: ChatMetadata;
  isError?: boolean;
  errorMessage?: string;
  guestQuotaExhausted?: boolean;
  guestMessagesRemaining?: number;
}

export interface InterviewSession {
  sessionId: string;
  userId: number;
  interviewType: InterviewType;
  jobRole?: string;
  companyName?: string;
  experienceLevel: ExperienceLevel;
  messages: ChatMessage[];
  startedAt: string;
  endedAt?: string;
  status: InterviewSessionStatus;
  summary?: InterviewSessionSummary;
}

export interface InterviewSessionSummary {
  totalQuestions: number;
  averageScore: number;
  strengthAreas: string[];
  improvementAreas: string[];
  overallFeedback: string[];
  duration: string;
}

export interface StartInterviewRequest {
  interviewType: InterviewType;
  jobRole?: string;
  companyName?: string;
  experienceLevel: ExperienceLevel;
}

export interface GenerateQuestionsRequest {
  interviewType: InterviewType;
  jobRole?: string;
  experienceLevel: ExperienceLevel;
  count: number;
}

export interface ChatConfig {
  interviewTypes: InterviewTypeInfo[];
  experienceLevels: ExperienceLevelInfo[];
}

export interface InterviewTypeInfo {
  type: InterviewType;
  name: string;
  description: string;
}

export interface ExperienceLevelInfo {
  level: ExperienceLevel;
  name: string;
  description: string;
}

export enum InterviewType {
  General = 0,
  Technical = 1,
  Behavioral = 2,
  SystemDesign = 3,
  Coding = 4,
  Leadership = 5,
  Product = 6
}

export enum ExperienceLevel {
  Intern = 0,
  EntryLevel = 1,
  MidLevel = 2,
  Senior = 3,
  Lead = 4,
  Principal = 5,
  Executive = 6
}

export enum InterviewSessionStatus {
  Active = 0,
  Completed = 1,
  Paused = 2,
  Cancelled = 3
}

